import { useMemo } from 'react';
import { useCustomTranslation } from '../../../../hooks';
import { useGanttStore } from '../Gantt/store';
import { NodeType } from '../Gantt/types';
import { useGanttInstanceId } from '../Gantt/utils';
import { NodeSingleSearchResult } from './NodeSingleSearchResult';
import { SearchResultsList } from './SearchResultsList';
import { searchNodes } from './searchNodes';
import { SingleNodeBatchSearchResult } from './SingleNodeBatchSearchResult';
import { useSyncSearchResults } from './useSyncSearchResults';

type GanttSearchResultsProps = {
  search: string;
};

export const GanttSearchResults = ({ search }: GanttSearchResultsProps) => {
  const instanceId = useGanttInstanceId();
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const selectSearchResults = useMemo(() => searchNodes(instanceId, search), [instanceId, search]);
  const searchResults = useGanttStore(selectSearchResults);

  const matchedIds = useMemo(() => searchResults.map(({ node }) => node.id), [searchResults]);
  useSyncSearchResults(matchedIds);

  return (
    <SearchResultsList bannerMessage={tWrapper('ganttSearchResultsBanner')} count={searchResults.length}>
      {searchResults.map(({ queue, node }, index) => {
        if (node.type === NodeType.TASK) {
          return <NodeSingleSearchResult key={`${index}-${node.id}`} node={node} queue={queue} />;
        }
        return <SingleNodeBatchSearchResult key={`${index}-${node.id}`} node={node} queue={queue} />;
      })}
    </SearchResultsList>
  );
};
